// Where leaving a proposal returns to: the deal's Terms & Services.
export const dealPath = (dealId: string) => `/deals/${dealId}?tab=commercials`;
